import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ListboxModule } from 'primeng/listbox';
import { FormsModule } from '@angular/forms';
import { ListBoxComponent } from '../../forms';

@Component({
  standalone: true,
  selector: 'lx-currency-list',
  imports: [CommonModule, ListboxModule, FormsModule, NgOptimizedImage, ListBoxComponent],
  templateUrl: './currency-list.component.html',
  styleUrls: ['./currency-list.component.scss'],
})
export class CurrencyListComponent implements OnChanges {
  @Input() currencies: string[] | undefined;
  @Input() selectedCurrency: string | undefined;

  @Output() selectedCurrencyChanged = new EventEmitter<string>();

  currency: string | undefined;
  // Sizes for the flag images
  readonly flagImageWidth = 30;
  readonly flagImageHeight = 15;

  ngOnChanges({ selectedCurrency }: SimpleChanges): void {
    if (selectedCurrency?.currentValue) {
      this.currency = this.selectedCurrency;
    }
  }
}
